import { useState as r, useCallback as f, Children as m, isValidElement as u, useEffect as C } from "react";
const b = (s) => {
  const [o, y] = r([]), t = f((p) => {
    m.map(p, (e) => {
      if (u(e) && (e != null && e.props.children))
        t(e.props.children);
      else {
        const a = e && typeof e == "object" && "type" in e && typeof e.type == "function" && "displayName" in e.type && typeof e.type.displayName == "string" ? e.type.displayName : typeof e;
        y((n) => [...n, a]);
      }
    });
  }, []);
  return C(() => {
    t(s);
  }, [s, t]), o.map((p) => p.toLowerCase());
};
export {
  b as useGetChildrenTypes
};
